// Auto-generated per-query builders for PDMAction
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { PDMActionReadAPI, PDMActionWriteAPI, PDMActionReadAPISchema, PDMActionWriteAPISchema } from '../types/pdmaction';
import { ModelRegistry } from '../../registries/model-registry';
import { ActionComposedOf, Allocation, AtScope, FlowConnection, HasActions, HasMembers, HasRequirements, Performs, Satisfaction, Specializes } from '../../relationships/relationship';

import { PartDefinition } from '../../sysml/api/partdefinition';
import { ActionDefinition } from '../../sysml/api/actiondefinition';
import { PDMRequirement } from './pdmrequirement';
import { SecurityScope } from '../../shared/api/securityscope';
import { SysMLNamespace } from '../../sysml/api/sysmlnamespace';
import { SysMLType } from '../../sysml/api/sysmltype';
import { RequirementDefinition } from '../../sysml/api/requirementdefinition';
import { PDMProduct } from './pdmproduct';




// Include spec for query: PdmActionByIdIncludeSpec
export interface PdmActionByIdIncludeSpec {
  sub_actions?: {
    _limit?: number;  // max 100
    performed_by?: {
      _limit?: number;  // max 10
    };
  };
  performed_by?: {
    _limit?: number;  // max 10
  };
  allocated_to?: {
    _limit?: number;  // max 10
  };
  satisfied_requirements?: {
    _limit?: number;  // max 50
  };
  parent_action?: {
    _limit?: number;  // max 1
  };
  current_threads?: {
    _limit?: number;  // max 10
  };
}


// Builder chain for query: pdm-action-by-id

export interface PdmActionByIdBuilder_0 {
  get(id: string): PdmActionByIdBuilder_1;
  filter(conditions: { id: string }): PdmActionByIdBuilder_1;
}

export interface PdmActionByIdBuilder_1 {
  load(include: PdmActionByIdIncludeSpec): PdmActionByIdBuilder_1;
  all(): Promise<PDMAction[]>;
  first(): Promise<PDMAction | null>;
  get(): Promise<PDMAction[]>;
  execute(): Promise<PDMAction[]>;
}


// Union of all query entry points
export type PDMActionQueryBuilder = PdmActionByIdBuilder_0;

// Available query names for .setQuery()
export type PDMActionQueryNames = "pdm-action-by-id";

// Type narrowing for .setQuery()
export type PDMActionBuilderForQuery<Q extends PDMActionQueryNames> =
  Q extends "pdm-action-by-id" ? PdmActionByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type PDMActionInstanceQueryResult<Q extends PDMActionQueryNames> =
  Q extends "pdm-action-by-id" ? PdmActionByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'pdm-action-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends PDMActionQueryNames>(queryName: Q): PDMActionBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface PDMAction extends Partial<PDMActionReadAPI> {}
export class PDMAction extends NeoNodeBase<PDMActionReadAPI, PDMActionWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "PDMAction";
  static readonly readSchema = PDMActionReadAPISchema;
  static readonly writeSchema = PDMActionWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    member_namespace: { target: "SysMLNamespace", cardinality: "one", isParent: false, relClass: "HasMembers", direction: "in" },
    general: { target: "SysMLType", cardinality: "many", isParent: false, relClass: "Specializes", direction: "out" },
    specific: { target: "SysMLType", cardinality: "many", isParent: false, relClass: "Specializes", direction: "in" },
    satisfied_requirements: { target: "RequirementDefinition", cardinality: "many", isParent: false, relClass: "Satisfaction", direction: "out" },
    allocated_to: { target: "PartDefinition", cardinality: "many", isParent: false, relClass: "Allocation", direction: "out" },
    performed_by: { target: "PartDefinition", cardinality: "many", isParent: false, relClass: "Performs", direction: "in" },
    sub_actions: { target: "ActionDefinition", cardinality: "many", isParent: false, relClass: "ActionComposedOf", direction: "out" },
    parent_action: { target: "ActionDefinition", cardinality: "one", isParent: true, relClass: "ActionComposedOf", direction: "in" },
    output_flows_to: { target: "ActionDefinition", cardinality: "many", isParent: false, relClass: "FlowConnection", direction: "out" },
    input_flows_from: { target: "ActionDefinition", cardinality: "many", isParent: false, relClass: "FlowConnection", direction: "in" },
    product: { target: "PDMProduct", cardinality: "one", isParent: true, relClass: "HasActions", direction: "in" },
    requirements: { target: "PDMRequirement", cardinality: "many", isParent: false, relClass: "HasRequirements", direction: "out" },
  };

  protected get modelName(): string {
    return 'PDMAction';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return PDMAction.label;
  }


  constructor(data: Partial<PDMActionWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: PDMActionReadAPI, loadContext?: Record<string, any>): PDMAction {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { satisfied_requirements, allocated_to, performed_by, sub_actions, parent_action, output_flows_to, input_flows_from, product, requirements, security_scope, member_namespace, general, specific, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = PDMActionReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, satisfied_requirements: satisfied_requirements, allocated_to: allocated_to, performed_by: performed_by, sub_actions: sub_actions, parent_action: parent_action, output_flows_to: output_flows_to, input_flows_from: input_flows_from, product: product, requirements: requirements, security_scope: security_scope, member_namespace: member_namespace, general: general, specific: specific };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return PDMAction.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadManyRelationship(processed, 'satisfied_requirements', 'RequirementDefinition', ModelRegistry);
    loadManyRelationship(processed, 'allocated_to', 'PartDefinition', ModelRegistry);
    loadManyRelationship(processed, 'performed_by', 'PartDefinition', ModelRegistry);
    loadManyRelationship(processed, 'sub_actions', 'ActionDefinition', ModelRegistry);
    loadManyRelationship(processed, 'parent_action', 'ActionDefinition', ModelRegistry);
    loadManyRelationship(processed, 'output_flows_to', 'ActionDefinition', ModelRegistry);
    loadManyRelationship(processed, 'input_flows_from', 'ActionDefinition', ModelRegistry);
    loadManyRelationship(processed, 'product', 'PDMProduct', ModelRegistry);
    loadManyRelationship(processed, 'requirements', 'PDMRequirement', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'member_namespace', 'SysMLNamespace', ModelRegistry);
    loadManyRelationship(processed, 'general', 'SysMLType', ModelRegistry);
    loadManyRelationship(processed, 'specific', 'SysMLType', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new PDMAction(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): PDMActionQueryBuilder {
    return new QueryBuilderImpl('PDMAction').filter(conditions) as any;
  }

  static all(): PDMActionQueryBuilder {
    return new QueryBuilderImpl('PDMAction') as any;
  }

  static async first(): Promise<PDMAction | null> {
    const results = await new QueryBuilderImpl('PDMAction').execute();
    return results[0] || null;
  }


  static setQuery<Q extends PDMActionQueryNames>(queryName: Q): PDMActionBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('PDMAction');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends PDMActionQueryNames>(queryName: Q): PDMActionInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = PDMAction.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const pdmaction = await PDMAction.get(id).first();
   * await pdmaction.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await pdmaction.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'performed_by' - Python ORM style (cached)
  get performed_by(): RelationshipManager<this, PartDefinition> {
    return this.getOrCreateRelationshipManager('performed_by', () => {
      return new RelationshipManager(this, 'performed_by', 'many', Performs as typeof Relationship);
    });
  }

  // Relationship manager for 'sub_actions' - Python ORM style (cached)
  get sub_actions(): RelationshipManager<this, ActionDefinition> {
    return this.getOrCreateRelationshipManager('sub_actions', () => {
      return new RelationshipManager(this, 'sub_actions', 'many', ActionComposedOf as typeof Relationship);
    });
  }

  // Relationship manager for 'requirements' - Python ORM style (cached)
  get requirements(): RelationshipManager<this, PDMRequirement> {
    return this.getOrCreateRelationshipManager('requirements', () => {
      return new RelationshipManager(this, 'requirements', 'many', HasRequirements as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'member_namespace' - Python ORM style (cached)
  get member_namespace(): RelationshipManager<this, SysMLNamespace> {
    return this.getOrCreateRelationshipManager('member_namespace', () => {
      return new RelationshipManager(this, 'member_namespace', 'one', HasMembers as typeof Relationship);
    });
  }

  // Relationship manager for 'general' - Python ORM style (cached)
  get general(): RelationshipManager<this, SysMLType> {
    return this.getOrCreateRelationshipManager('general', () => {
      return new RelationshipManager(this, 'general', 'many', Specializes as typeof Relationship);
    });
  }

  // Relationship manager for 'specific' - Python ORM style (cached)
  get specific(): RelationshipManager<this, SysMLType> {
    return this.getOrCreateRelationshipManager('specific', () => {
      return new RelationshipManager(this, 'specific', 'many', Specializes as typeof Relationship);
    });
  }

  // Relationship manager for 'satisfied_requirements' - Python ORM style (cached)
  get satisfied_requirements(): RelationshipManager<this, RequirementDefinition> {
    return this.getOrCreateRelationshipManager('satisfied_requirements', () => {
      return new RelationshipManager(this, 'satisfied_requirements', 'many', Satisfaction as typeof Relationship);
    });
  }

  // Relationship manager for 'allocated_to' - Python ORM style (cached)
  get allocated_to(): RelationshipManager<this, PartDefinition> {
    return this.getOrCreateRelationshipManager('allocated_to', () => {
      return new RelationshipManager(this, 'allocated_to', 'many', Allocation as typeof Relationship);
    });
  }

  // Relationship manager for 'parent_action' - Python ORM style (cached)
  get parent_action(): RelationshipManager<this, ActionDefinition> {
    return this.getOrCreateRelationshipManager('parent_action', () => {
      return new RelationshipManager(this, 'parent_action', 'one', ActionComposedOf as typeof Relationship);
    });
  }

  // Relationship manager for 'output_flows_to' - Python ORM style (cached)
  get output_flows_to(): RelationshipManager<this, ActionDefinition> {
    return this.getOrCreateRelationshipManager('output_flows_to', () => {
      return new RelationshipManager(this, 'output_flows_to', 'many', FlowConnection as typeof Relationship);
    });
  }

  // Relationship manager for 'input_flows_from' - Python ORM style (cached)
  get input_flows_from(): RelationshipManager<this, ActionDefinition> {
    return this.getOrCreateRelationshipManager('input_flows_from', () => {
      return new RelationshipManager(this, 'input_flows_from', 'many', FlowConnection as typeof Relationship);
    });
  }

  // Relationship manager for 'product' - Python ORM style (cached)
  get product(): RelationshipManager<this, PDMProduct> {
    return this.getOrCreateRelationshipManager('product', () => {
      return new RelationshipManager(this, 'product', 'one', HasActions as typeof Relationship);
    });
  }

}
